import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

export default class QueryManager extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        fetchPolicy: PropTypes.string,
        query: PropTypes.object,
        variables: PropTypes.object
    }

    render () {
        const { children, query, fetchPolicy, variables = {}, ...props } = this.props;

        return (
            <Query
                query={query}
                notifyOnNetworkStatusChange
                fetchPolicy={fetchPolicy || 'network-only'}
                variables={variables}
                {...props}
            >
                {({ loading, error, data, fetchMore, refetch, client, networkStatus, ...props }) => {
                    return children({
                        data,
                        loading,
                        error,
                        fetchMore,
                        refetch,
                        client,
                        networkStatus
                    });
                }}
            </Query>
        );
    }
}
